import { Redirect, Route, Switch } from 'react-router-dom';
import { SimpleTab } from '../../../../Component/Common/Components/Tabs/SimpleTab';
import { bbbeeModule } from '../../../../Component/Common/Constants/routes';
import { VerificationProcessStatus } from '../../../../Component/Model/Enum/BEE123Enums';
import { useRouteMatch } from '../../../../Helpers/RouteMatcher';
import { PlannerCards } from './PlannerCards';
import { useRecoilValue } from 'recoil';
import { BBBEEScorecardAtom } from '../../../../State/BBBEEScorecard.Atom';


export const Planner = () => {
    const scorecard = useRecoilValue(BBBEEScorecardAtom);

    const routes = [
        `/bee/scorecard/${scorecard.scorecardId}/${bbbeeModule.verificationProcess}/${bbbeeModule.plannerAndTracker}/all`,
        `/bee/scorecard/${scorecard.scorecardId}/${bbbeeModule.verificationProcess}/${bbbeeModule.plannerAndTracker}/planned`,
        `/bee/scorecard/${scorecard.scorecardId}/${bbbeeModule.verificationProcess}/${bbbeeModule.plannerAndTracker}/inProgress`,
        `/bee/scorecard/${scorecard.scorecardId}/${bbbeeModule.verificationProcess}/${bbbeeModule.plannerAndTracker}/completed`
    ];
    const labels = ['All', 'Planned', 'In Progress', 'Completed'];
    const tabsData = routes.map((route, index) => ({
        route,
        label: labels[index]
    }));

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    return (
        <>
            <SimpleTab currentTab={currentTab} tabsData={tabsData} />
            <Switch>
                {handleRedirect()}
                <Route path={routes[0]}>
                    <PlannerCards scorecardId={scorecard.scorecardId} />
                </Route>
                <Route path={routes[1]}>
                    <PlannerCards scorecardId={scorecard.scorecardId} status={VerificationProcessStatus.Planned} />
                </Route>
                <Route path={routes[2]}>
                    <PlannerCards scorecardId={scorecard.scorecardId} status={VerificationProcessStatus['In Progress']} />
                </Route>
                <Route path={routes[3]}>
                    <PlannerCards scorecardId={scorecard.scorecardId} status={VerificationProcessStatus.Completed} />
                </Route>
            </Switch>
        </>
    )
}
